'use client';

import Image from "next/image"

const coreValues = [
    {
        icon: '/innovation.svg',
        title: 'Innovation',
        description:
            'Constantly pushing the limits of web-based compilers to provide a seamless experience.',
    },
    {
        icon: '/community.svg',
        title: 'Community',
        description:
            'Built by researchers, for researchers. We grow through your feedback and success.',
    },
    {
        icon: '/speed.svg',
        title: 'Speed',
        description:
            'Every millisecond saved is more time for your research. Speed is our core feature.',
    },
];

export default function AboutPage() {
    return (
        <>
            <main>
                <section className="bg-background py-16 md:py-24 px-4">
                    <div className="max-w-5xl mx-auto">
                        <div className="text-center mb-12">
                            <h1 className="text-4xl md:text-5xl font-bold mb-4">
                                Building the future of{' '}
                                <span className="text-primary">technical</span> writing.
                            </h1>
                            <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
                                We are on a mission to make complex technology development easy
                                for researchers, students, and engineers worldwide.
                            </p>
                        </div>

                        {/* Main Content Section */}
                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center mb-16">
                            <div>
                                <h2 className="text-3xl font-bold mb-4">
                                    Empowering the next generation of researchers.
                                </h2>
                                <p className="text-muted-foreground mb-4 leading-relaxed">
                                    Rudrise was born out of a simple necessity: to make technical
                                    writing as fast as the ideas behind it. We understand that LaTeX
                                    is the gold standard for precision, but its complexity often
                                    creates a barrier to entry.
                                </p>
                                <p className="text-muted-foreground mb-4 leading-relaxed">
                                    Our team is dedicated to building a seamless, web-based
                                    environment where students and professionals can collaborate in
                                    real-time. By automating the difficult parts of environment setup
                                    and package management, we allow you to focus entirely on your
                                    breakthrough discoveries. We believe that when your tools are
                                    intuitive, your potential is limitless.
                                </p>
                            </div>

                            {/* Image Placeholder */}
                            <div className="bg-gray-900 rounded-2xl h-80 flex items-center justify-center border border-border">
                                <div className="text-center">
                                    <div className="text-6xl mb-2">💻</div>
                                    <p className="text-muted-foreground text-sm">
                                        Technical Code Screenshot
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* Core Values */}
                        <div className="mb-12">
                            <h2 className="text-2xl font-bold text-center mb-3">
                                OUR CORE VALUES
                            </h2>
                            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                                {coreValues.map((value, idx) => (
                                    <div
                                        key={idx}
                                        className="border border-border rounded-lg p-6 text-center"
                                    >
                                        <Image
                                            src={value.icon}
                                            alt={`${value.title} Icon`}
                                            width={40}
                                            height={40}
                                            className="mx-auto mb-4 object-contain"
                                        />
                                        <h3 className="text-xl font-bold mb-2">{value.title}</h3>
                                        <p className="text-muted-foreground text-sm">
                                            {value.description}
                                        </p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </section>
            </main>
        </>
    );
}
